import { render } from "./CertificationIndex.vue?vue&type=template&id=4fb91234&scoped=true&ts=true"
import script from "./CertificationIndex.vue?vue&type=script&lang=ts"
export * from "./CertificationIndex.vue?vue&type=script&lang=ts"

import "./CertificationIndex.vue?vue&type=style&index=0&id=4fb91234&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb91234"]])

export default __exports__